import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { AbstractBaseFieldComponent } from '@shared/components/form-elements/abstract-field-base';
import { FormErrorsModule } from '@shared/components/form-elements/form-errors/form-errors.module';

@Component({
  selector: 'cx-input-field',
  imports: [CommonModule, FormsModule, FormErrorsModule, NgxMaskDirective],
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss'],
  providers: [
    provideNgxMask(),
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFieldComponent),
      multi: true,
    },
  ],
  host: {
    '[attr.id]': 'null',
  },
})
export class InputFieldComponent extends AbstractBaseFieldComponent implements ControlValueAccessor {
  @Input() control?: AbstractControl | null;
  @Input() label = '';
  @Input() hintText = '';
  @Input() icon = '';
  @Input() id = this.generateId();
  @Input() type = 'text';
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() readonly = false;
  @Input() minLength?: number;
  @Input() maxLength?: number;
  @Input() mask?: string;
  @Input() isPassword = false;
  @Input() valid?: boolean;
  @Input() invalid?: boolean;
  @Input() iconPosition?: 'start' | 'end';

  pwIsVisible = false;

  handlerVisibility() {
    this.pwIsVisible = !this.pwIsVisible;
    this.type = this.pwIsVisible ? 'text' : 'password';
  }
}
